import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useState, useEffect, useCallback } from "react";
import gatewayApi from "../api/gatewayApi";
const AuthContext = createContext({
    isAuthenticated: false,
    isLoading: true,
    user: null,
    error: null,
    login: () => { },
    logout: () => { },
    refreshUser: async () => { }
});
export const AuthProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [error, setError] = useState(null);
    const refreshUser = useCallback(async () => {
        if (!gatewayApi.isAuthenticated()) {
            setIsLoading(false);
            return;
        }
        try {
            const me = await gatewayApi.getMe();
            setUser(me);
            setError(null);
        }
        catch (err) {
            if (err instanceof Error && err.message === "UNAUTHORIZED") {
                setUser(null);
            }
            else {
                setError(err instanceof Error ? err.message : "Failed to load user");
            }
        }
        finally {
            setIsLoading(false);
        }
    }, []);
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");
        if (token) {
            window.history.replaceState({}, document.title, window.location.pathname);
            gatewayApi.setToken(token);
        }
        else if (process.env.BUILD_TARGET === "dev:local" && !gatewayApi.isAuthenticated()) {
            // Auto-seed a placeholder token so MSW mock of /me is reachable locally
            gatewayApi.setToken("dev-mock-token");
        }
        void refreshUser();
    }, [refreshUser]);
    const login = useCallback(() => {
        gatewayApi.initiateLogin();
    }, []);
    const logout = useCallback(() => {
        gatewayApi.clearToken();
        setUser(null);
    }, []);
    return (_jsx(AuthContext.Provider, { value: {
            isAuthenticated: user !== null,
            isLoading,
            user,
            error,
            login,
            logout,
            refreshUser
        }, children: children }));
};
export default AuthContext;
